import React from 'react'
import PropTypes from 'prop-types';

import PackageChangeDialog from './PackageChangeDialog'
import {FlatButton, FontIcon, IconButton, IconMenu, MenuItem} from 'material-ui'
import PackageDeleteDialog from './PackageDeleteDialog'
import {translate} from "react-i18next";
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ExportDialog from './export/ExportDialog'


const ChangeDialogMenuItem = (props) => (
    <MenuItem onClick={props.onClick} leftIcon={
        <FontIcon style={{fontSize: '20px'}} className="material-icons">edit</FontIcon>} primaryText={props.t('edit')}>{props.children}</MenuItem>
)

const PublishDialogButton = (props) => (
    <FlatButton onClick={props.onClick} icon={
        <FontIcon style={{fontSize: '18px'}} className="material-icons">publish</FontIcon>} label={props.t('dialog_publish')}>{props.children}</FlatButton>
)


const TransChangeDialogMenuItem = translate()(ChangeDialogMenuItem)
const TransPublishDialogButton = translate()(PublishDialogButton)


class PackageDetailToolbar extends React.Component {

    state = {
        deleteDialogOpened: false,
        changeDialogOpened: false,
        publishDialogOpened: false,
    }

    toggleDeleteDialog = () => {
        this.setState({
            deleteDialogOpened: !this.state.deleteDialogOpened
        })
    }

    toggleChangeDialog = () => {
        this.setState({
            changeDialogOpened: !this.state.changeDialogOpened
        })
    }

    togglePublishDialog = () => {
        this.setState({
            publishDialogOpened: !this.state.publishDialogOpened
        })
    }

    render() {
        const {pckg, cards, t, nativeLang, foreignLang} = this.props
        return (
            <div style={{float: 'right',}}>
                <PackageDeleteDialog onCancelClick={this.toggleDeleteDialog} open={this.state.deleteDialogOpened} package={pckg}/>
                <PackageChangeDialog key={"publish"} onCancelClick={this.togglePublishDialog} package={pckg} userName={this.props.me ? this.props.me.name: null} cards={cards} initialValues={{published: true}} open={this.state.publishDialogOpened}/>
                <PackageChangeDialog key={"change"} onCancelClick={this.toggleChangeDialog} package={pckg} userName={this.props.me ? this.props.me.name: null} cards={cards} open={this.state.changeDialogOpened}/>
                <FlatButton
                    // icon={<FontIcon style={{fontSize: '18px'}} className="material-icons">import_export</FontIcon>}
                    label={this.props.t('mass_import_dialog_button_text')} onClick={this.props.onImportBtnClick}
                />
                <ExportDialog package={pckg}/>
                {pckg.published ? null : <TransPublishDialogButton onClick={this.togglePublishDialog}/>}
                <IconMenu style={{float: 'right',}}
                          iconButtonElement={
                              <IconButton style={{padding: 0, height: '30px', paddingTop: '3px'}}><MoreVertIcon/></IconButton>
                          }
                          targetOrigin={{horizontal: 'right', vertical: 'top'}}
                          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                >
                    <TransChangeDialogMenuItem onClick={this.toggleChangeDialog}/>
                    <MenuItem leftIcon={
                        <FontIcon style={{fontSize: '20px'}} className="material-icons">delete</FontIcon>} primaryText={this.props.t('delete')} onClick={this.toggleDeleteDialog}/>
                </IconMenu>
            </div>
        )
    }
}

PackageDetailToolbar.propTypes = {
    pckg: PropTypes.object.isRequired
}

export default translate()(PackageDetailToolbar)


// WEBPACK FOOTER //
// ./src/components/packages/PackageDetailToolbar.js